// extracted by mini-css-extract-plugin
export default {"root":"PlasmicUploadCsv_root__le6FV","text":"PlasmicUploadCsv_text__vc6f4"};